
export default {
  name:"moreLink",
  props:{
    title:{
      type:String,
      default:""
    },
    path:{
      type:String,
      default:""
    }
  },
  data() {
    return {

    }
  },
  methods:{
    goNext(){
      this.$router.push(this.localePath(this.path));
    }
  }
}
